import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Observable, Subject, Subscription } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { AuthorizeService } from 'src/app/_core/access-control/authorize.service';
import { ProspektrApi } from 'src/app/_shared/api/prospektr.api';
import { PaginatedBackendResponse } from 'src/app/_shared/interface/common.interface';
import { MultiSelectOption } from 'src/app/_shared/interface/multi-select.interface';
import { SavedSearchService } from 'src/app/_shared/service/saved-search.service';
import { AppState } from 'src/app/app.state';
import { PropertyFilterService } from 'src/app/property-filter/service/property-filter.service';
import constants from 'src/constant.json';
import { ConfirmDialogComponent } from '../../../shared/modules/alerts/confirm-dialog/confirm-dialog.component';
import { ClientDashboardService } from '../../service/client-dashboard.service';
import { ClientDashboardState } from '../../state/client-dashboard.state';
import { NotesComponent } from '../notes/notes.component';

interface savedDeals {
  address: string;
  count: number;
  lastUpdated: string;
}

interface myHomeProperty {
  createdDate: number;
  streetAddress: string;
  city: string;
  state: string;
  zip: string;
}

interface activityLogs {
  category: string;
  action: string;
  details: string;
  count: number;
  lastLogged: string;
}

interface qaSection {
  slNo: number;
  question: string;
  response: string;
}
interface notesSection {
  slNo: number;
  message: string;
  author: string;
  date: string;
}
interface sentMails {
  subject: number;
  sentDate: string;
  sentStatus: string;
  attachments: string;
}

@Component({
  selector: 'app-client-detail-sheet',
  templateUrl: './client-detail-sheet.component.html',
  styleUrls: ['./client-detail-sheet.component.scss'],
})
export class ClientDetailSheetComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('sentMailDataPaginator') sentMailDataPaginator: MatPaginator;
  sentMailData$: Observable<Array<any>>;
  expandListingsTab: boolean = false;
  @ViewChild('contactGroupPaginator', { static: false }) set contactGroupPaginator(paginator4: MatPaginator) {
    this.myHomePropertySource.paginator = paginator4;
  }
  clientDetailsSheetActive = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('savedSearchPaginator') savedSearchPaginator: MatPaginator;
  @ViewChild(MatPaginator) myListingsPaginator: MatPaginator;

  dataSource: MatTableDataSource<Array<any>>;

  savedDealDataSource = new MatTableDataSource<savedDeals>([]);
  myHomePropertySource = new MatTableDataSource<myHomeProperty>([]);
  sentMailDataSource = new MatTableDataSource<sentMails>([]);

  activityLogDataSource = new MatTableDataSource<activityLogs>([]);
  qaDataSource = new MatTableDataSource<qaSection>([]);
  noteDataSource = new MatTableDataSource([]);
  savedDealsColumnList: string[] = ['address', 'count', 'lastUpdated'];
  myHomeColumnList: string[] = ['address', 'createdDate', 'source'];
  actionsColumnList: string[] = ['category', 'action', 'lastLogged', 'details'];
  qaColumnList: string[] = ['slNo', 'question', 'response'];
  notesColumnList: string[] = ['message', 'author', 'date', 'action'];
  @ViewChild(MatPaginator) paginator1: MatPaginator;
  @ViewChild(MatSort) sort1: MatSort;
  sentMailColumnList: string[] = ['authorName', 'subject', 'sentDate', 'attachments', 'sentStatus'];
  activeClient: any = {};
  isSavedDealLoading: boolean = false;
  savedDealCount: number;
  myPropertyCount = 0;
  myPropertyLoading: boolean = false;
  isActivityLogLoading: boolean = false;
  isSentMailDataLoading: boolean = false;
  activityLogCount: number;
  sentMailCount: number;
  totalSavedDeals: number;
  totalLoggedActivities: number;
  result: [];
  constant: any = constants;
  logData = constants.LOGGER;
  actionName: string;
  data: any = {};
  isDisableResetBtn = false;
  isAgentList = false;
  isReassignAgent = true;
  selectedAgentId: any;
  selectedLeadStatus: any;
  connectionAgentInfo: any = {};
  connectionLoanOfficerInfo: any = {};
  clientListForDropdown = [];
  onDestroyNotifier$ = new Subject();
  myControl = new FormControl('');
  agentIdList = [];
  isSubmitInProgress: boolean = false;
  leadStatusList: Array<{ index: string; displayText: string }> = [];
  filteredAgentList: Observable<string[]>;
  isResendActivationInProgress: boolean = false;
  multiSelectOptions: MultiSelectOption[] = [];
  multiSelectOptionsForLoanOfficer: MultiSelectOption[] = [];
  isClientFormValid: boolean = true;
  hasMoreClientUsers: boolean = true;
  reloadSentMailData: boolean = false;
  hasMoreLoanOfficers = false;
  leadStatusForm: FormGroup = this._formBuilder.group({
    leadType: [],
    leadStatus: [],
  });
  isLoanOfficerList = false;
  isReassignLoanOfficer = true;
  activeAgentsAndLoanOfficersForManagerListSub = new Subscription();
  clientUserFetchParams = { userType: 'agent', limit: 20, offset: 0, searchQuery: null };
  loanOfficerUserFetchParams = { userType: 'loanOfficer', limit: 20, offset: 0, searchQuery: null };
  selectedLoanOfficersId: any;
  savedSearchList$: Observable<Array<any>>;
  isDataLoading = true;
  isSavedSearchLoading: boolean = false;
  count: any;
  fileArray: any;
  sentMailDetails: any;
  sentMailDataSheetValue = false;
  InvestorleadType: string;
  propertyList: any[] = [];
  investor_Id: string;
  companyName: string;
  notesResult = [];
  propertyTotalCount: any;
  includePropertyAddress: boolean = true;
  isValueTest: boolean = false;
  loadListings: boolean = true;
  constructor(
    public clientDashboardState: ClientDashboardState,
    private clientDashboardService: ClientDashboardService,
    public authorizeService: AuthorizeService,
    private snackBar: MatSnackBar,
    public appState: AppState,
    private _formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<NotesComponent>,
    private savedSearchService: SavedSearchService,
    private router: Router,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private ProspektrApi: ProspektrApi,
    public propertyFilterService: PropertyFilterService,
    public userState: AppState
  ) { }

  ngOnInit() {
    this.includePropertyAddress = true;
    this.clientDashboardState.openClientDetailsSheet$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((status) => {
      this.clientDetailsSheetActive = status;
    });
    this.isValueTest = this.appState?.appCompanyAliasValue === 'valuetest';

    this.clientDashboardState.activeClientDetails$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((data: any) => {
      if (data && data.openClientDetails) {
        this.expandListingsTab = true
      }


      if (data && data.questionnaire) {
        this.qaDataSource = new MatTableDataSource(Object.values(data.questionnaire));
      }
      this.activeClient = data;
      this.InvestorleadType = data?.leadType;
      this.investor_Id = data._id;
      this.companyName = this.appState.companyInfoValue.alias;
      if (data.leadType) {
        this.leadStatusList = Object.entries(this.appState.companyInfoValue[`${data?.leadType}LeadCategory`]).map(
          ([key, category]: any) => {
            return { index: key, displayText: category.displayText };
          }
        );
      }
      this.leadStatusForm.patchValue(
        {
          leadType: data?.leadType,
          leadStatus: data?.leadStatus?.toString(),
        },
        { emitEvent: false }
      );

      this.filteredAgentList = this.myControl.valueChanges.pipe(
        startWith(''),
        map((value) => this._filter(value || ''))
      );

      if (this.authorizeService.canView('clientUsers')) {
        this.clientDashboardService
          .fetchAgentsAndLoanOfficersReassign(this.clientUserFetchParams)
          .pipe(takeUntil(this.onDestroyNotifier$))
          .subscribe((res: any) => { });

        this.clientDashboardService
          .fetchLoanOfficers(this.loanOfficerUserFetchParams)
          .pipe(takeUntil(this.onDestroyNotifier$))
          .subscribe((res: any) => { });
      }
      this.myHomeProperties(data._id);
      this.fetchSavedDeals({ userId: data._id });
      this.fetchLoggedActivities({ userId: data._id });
      this.fetchConnectionDetails(data._id);
      this.fetchUserNotes(data._id);
    });
    this.fetchSentMailData(this.activeClient._id);

    this.clientDashboardState.userNoteList$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      if (res) {
        this.notesResult = res;
        this.noteDataSource = new MatTableDataSource(this.notesResult);
        this.noteDataSource.paginator = this.paginator1;
        this.noteDataSource.sort = this.sort1;
      }
    });

    this.clientDashboardState.myPropertyList$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      if (res) {
        this.myHomePropertySource = new MatTableDataSource(res.data ? res.data : []);
        this.myPropertyCount = res.totalRecords;
      }
    });

    this.fetchSavedSearchDetails(this.activeClient._id);

    this.clientDashboardState.savedSearch$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      let savedSearchList = this.getFormattedSavedSearchList(res);
      this.cdr.detectChanges();
      this.dataSource = new MatTableDataSource(savedSearchList);
      this.dataSource.paginator = this.savedSearchPaginator;
      this.savedSearchList$ = this.dataSource.connect();
    });

    this.clientDashboardState.savedDealData$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      this.savedDealDataSource = new MatTableDataSource(res.records ? res.records : res);
      this.savedDealCount = res.totalRecordCount ? res.totalRecordCount : 0;
      this.totalSavedDeals = res.totalSavedDealCount ? res.totalSavedDealCount : 0;
    });

    this.clientDashboardState.sentMailData$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      this.sentMailDetails = res;
      this.sentMailDataSource = new MatTableDataSource(res.records ? res.records : res);
      this.sentMailDataSource.paginator = this.sentMailDataPaginator;
      this.sentMailData$ = this.sentMailDataSource.connect();
      this.sentMailCount = res.length;
      this.cdr.detectChanges();

      res = res.map((element: any) => {
        let attachments = [];
        element.attachmentList.map((file) => {
          attachments.push(file.filename);
          element.file = attachments;
        });
        return element;
      });
    });
    this.clientDashboardState.activityLogData$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      let data = [];
      if (res.records && res.records.length) {
        res.records = res.records.map((element: any) => {
          if (
            this.logData[element.category] &&
            this.logData[element.category].action[element.action] &&
            element.action &&
            element.category
          ) {
            element.actionName = this.logData[element.category].action[element.action].displayValue;
          } else {
            element.actionName = element.action;
          }
          if (this.logData[element.category] && element.category) {
            element.categoryName = this.logData[element.category].displayValue;
          } else {
            element.categoryName = element.category;
          }
          if (element.fullAddress) {
            element.details = element.fullAddress;
          } else if (
            element.address &&
            element.address['street'] &&
            element.address['city'] &&
            element.address['state'] &&
            element.address['zip']
          ) {
            element.details =
              element.address['street'] +
              ', ' +
              element.address['city'] +
              ', ' +
              element.address['state'] +
              ' ' +
              element.address['zip'];
          }
          if (element.action == 'signUp' && constants.SIGN_UP.sourceValue[element.source]) {
            element.details = constants.SIGN_UP.sourceValue[element.source];
          } else if (element.action == 'signUp' && !constants.SIGN_UP.sourceValue[element.source] && !element.source) {
            element.details = 'From External Source';
          }
          if (element.action == 'signUp' && !constants.SIGN_UP.sourceValue[element.source] && element.source) {
            element.details = 'From' + ' ' + element.source;
          }
          if (element.action == 'shareProperty') {
            element.details = element.email;
          }
          if (element.action == 'agentContact') {
            element.details = element.message;
          }
          if (element.action == 'updated questionaire') {
            let logQuestions: any[] = [];
            for (const key in element.questionaireData) {
              if (element.questionaireData.hasOwnProperty(key)) {
                const questionData = element.questionaireData[key];
                let newValue: any = {
                  Question: questionData.question,
                  Answer: questionData.updatedResponse,
                };
                logQuestions.push(newValue);
              }
            }
            element.details = this.removeSymbols(JSON.stringify(logQuestions));
          }
          return element;
        });
      } else {
        res.records = [];
      }
      this.activityLogDataSource = new MatTableDataSource(res.records ? res.records : res);
      this.activityLogCount = res.totalRecordCount ? res.totalRecordCount : 0;
      this.totalLoggedActivities = res.totalActivityCount ? res.totalActivityCount : 0;
    });

    this.clientDashboardState.savedAgentConnectionData$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        if (res?.length) {
          this.connectionAgentInfo = res.find((user) => user.roles.includes('agent'));
          this.connectionLoanOfficerInfo = res.find((user) => user.roles.includes('loanOfficer'));
        }
      });

    this.fetchListings({ userId: this.investor_Id });
  }

  ngAfterViewInit(): void {
    this.subscribeLeadFormChanges();
  }

  getFormattedSavedSearchList(savedSearchList) {
    for (let i = 0; i < savedSearchList.length; i++) {
      if (savedSearchList[i].appliedFilter?.filters) {
        let savedList = this.propertyFilterService.getFilterDisplayList(savedSearchList[i].appliedFilter?.filters);
        savedSearchList[i]['filterList'] = savedList;
      }
    }
    return savedSearchList;
  }

  fetchConnectionDetails(params) {
    this.clientDashboardService
      .getConnectionDetails(params)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => { });
  }

  fetchUserNotes(InvestorId) {
    this.clientDashboardService
      .getUsersNotes(InvestorId)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => { });
  }

  myHomeProperties(InvestorId) {
    this.clientDashboardService
      .getMyHomeProperties(InvestorId)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        this.myPropertyLoading = res.isLoading;
      });
  }
  removeSymbols(inputString) {
    let stringWithoutBrackets = inputString.replace(/[\[\]{}]/g, '');
    let stringWithoutQuotes = stringWithoutBrackets.replace(/"/g, '');
    let pairs = stringWithoutQuotes.split(',Question:');

    for (let i = 1; i < pairs.length; i++) {
      pairs[i] = '  Question: ' + pairs[i];
    }
    let stringWithSpaces = pairs.join(', ');
    stringWithSpaces = stringWithSpaces.replace(/\?/g, '?  ');
    stringWithSpaces = stringWithSpaces.replace(/:/g, ': ');
    stringWithSpaces = stringWithSpaces.replace(/,/g, '');
    return stringWithSpaces;
  }

  closeClientDetailSheet() {
    // this.propertyFilterState.savedFiltersValue = null;

    this.myControl.reset();
    this.clientDashboardState.savedAgentConnectionDataValue = [];
    this.clientDashboardState.openClientDetailsSheetValue = false;
    this.clientDashboardState.savedDealDataValue = [];
    this.clientDashboardState.activityLogDataValue = [];
    this.connectionLoanOfficerInfo = {};
    this.connectionAgentInfo = {};
    // this.router.navigate([], {
    //   queryParams: {},
    //   replaceUrl: true,
    //   state: { skipUpdate: true },
    // });
  }

  pageChangeOnlistings(event) {
    let params = {
      userId: this.investor_Id,
      limit: event.pageSize,
      offset: event.pageSize * event.pageIndex,
    };

    this.fetchListings(params);
  }

  pageChangeOnSavedDeals(event) {
    let params = {
      userId: this.activeClient._id,
      limit: event.pageSize,
      offset: event.pageSize * event.pageIndex,
    };
    this.fetchSavedDeals(params);
  }

  pageChangeOnActivityLogs(event) {
    let params = {
      userId: this.activeClient._id,
      limit: event.pageSize,
      offset: event.pageSize * event.pageIndex,
    };

    this.fetchLoggedActivities(params);
  }

  fetchSavedDeals(params) {
    params = { ...params, limit: params.limit ? params.limit : 5, offset: params.offset ? params.offset : 0 };
    this.clientDashboardService
      .getSavedDeals(params)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        this.isSavedDealLoading = res.isLoading;
      });
  }

  fetchSavedSearchDetails(investorId) {
    this.savedSearchService
      .getSavedSearchForClients(investorId)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(({ isLoading }) => (this.isSavedSearchLoading = isLoading));
  }

  fetchLoggedActivities(params) {
    params = {
      ...params,
      limit: params.limit ? params.limit : 5,
      offset: params.offset ? params.offset : 0,
    };
    this.clientDashboardService
      .getLoggedActivities(params)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        this.isActivityLogLoading = res.isLoading;
      });
  }

  fetchListings(params) {
    params = { ...params, limit: params.limit ? params.limit : 2, offset: params.offset ? params.offset : 0 };

    this.ProspektrApi.getMyListings(params)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        this.loadListings = true;
        if (res) {
          this.loadListings = false;
        }
        this.propertyList = res.data.records;
        this.propertyTotalCount = res.data.totalRecordCount;
      });
  }

  fetchSentMailData(id) {
    this.clientDashboardService
      .getSentMails(id)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        this.isSentMailDataLoading = res.isLoading;
      });
    this.cdr.detectChanges();
  }

  openSentMailDataSheet(sentMailData) {
    this.clientDashboardState.activeSentMailValue = sentMailData;
    this.clientDashboardState.openSentMailDataSheetValue = true;
  }

  openCreateMailSheet() {
    this.clientDashboardState.openCreateMailSheetValue = true;
  }

  reassignAgent() {
    this.isAgentList = true;
    this.isReassignAgent = false;
    this.clientDashboardState.clientUserDetail$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((clientUserList: PaginatedBackendResponse) => {
        if (this.clientUserFetchParams.offset == 0) this.multiSelectOptions = [];
        this.multiSelectOptions = JSON.parse(
          JSON.stringify(
            clientUserList?.data?.reduce((filtered, client) => {
              if (client.userType == 'agent')
                filtered.push({
                  displayText: `${client.firstName} ${client.lastName}`,
                  value: client._id,
                } as MultiSelectOption);
              return filtered;
            }, this.multiSelectOptions) || []
          )
        );
        if (clientUserList?.data?.length == clientUserList?.totalCount) {
          this.hasMoreClientUsers = false;
        }
        if (clientUserList?.data?.length) this.clientUserFetchParams.offset += 20;
      });
  }

  reassignLoanOfficer() {
    this.isLoanOfficerList = true;
    this.isReassignLoanOfficer = false;
    this.clientDashboardState.loanOfficerList$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((loanOfficerList: PaginatedBackendResponse) => {
        if (this.loanOfficerUserFetchParams.offset == 0) this.multiSelectOptionsForLoanOfficer = [];
        this.multiSelectOptionsForLoanOfficer = JSON.parse(
          JSON.stringify(
            loanOfficerList?.data?.reduce((filtered, client) => {
              if (client.userType == 'loanOfficer')
                filtered.push({
                  displayText: `${client.firstName} ${client.lastName}`,
                  value: client._id,
                } as MultiSelectOption);

              return filtered;
            }, this.multiSelectOptionsForLoanOfficer) || []
          )
        );
        if (loanOfficerList?.data?.length != 0 && loanOfficerList?.data?.length == loanOfficerList?.totalCount) {
          this.hasMoreLoanOfficers = false;
        }
        if (loanOfficerList?.data?.length) this.loanOfficerUserFetchParams.offset += 20;
      });
  }

  fetchNextClientUserList() {
    this.clientDashboardService
      .fetchAgentsAndLoanOfficersReassign(this.clientUserFetchParams)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        if (res?.data && !res.data?.data?.length) this.hasMoreClientUsers = false;
      });
  }

  fetchNextLoanOfficerUserList() {
    this.clientDashboardService
      .fetchLoanOfficers(this.loanOfficerUserFetchParams)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        if (res?.data && !res.data?.data?.length) this.hasMoreLoanOfficers = false;
      });
  }

  searchLoanOfficerUser(searchText: string) {
    this.hasMoreLoanOfficers = true;
    this.loanOfficerUserFetchParams.offset = 0;
    this.loanOfficerUserFetchParams.searchQuery = searchText;
    this.fetchNextLoanOfficerUserList();
  }

  searchClientUser(searchText: string) {
    this.hasMoreClientUsers = true;
    this.clientUserFetchParams.offset = 0;
    this.clientUserFetchParams.searchQuery = searchText;
    this.fetchNextClientUserList();
  }

  updateSelectedOptions($event: Array<MultiSelectOption>, role) {
    if (role == 'agent') {
      this.selectedAgentId = $event?.map((option) => option.value)[0];
    }

    if (role == 'loanOfficer') {
      this.selectedLoanOfficersId = $event?.map((option) => option.value)[0];
    }
  }
  openSnackBar(message, style) {
    if (message) {
      this.snackBar.open(message, '', {
        duration: 3000,
        panelClass: [style ? style : ''],
        verticalPosition: 'top',
      });
    }
  }

  cancelAgent() {
    this.myControl.reset();
    this.isAgentList = false;
    this.isReassignAgent = true;
    this.selectedAgentId = null;
  }

  cancelLoanOfficer() {
    this.myControl.reset();
    this.isLoanOfficerList = false;
    this.isReassignLoanOfficer = true;
    this.selectedAgentId = null;
  }

  updateAgentDetails() {
    if (!this.selectedAgentId) return;
    const params = {
      agentId: this.selectedAgentId,
    };
    this.updateReassignDetails(params);
  }

  updateLoanOfficerDetails() {
    if (!this.selectedLoanOfficersId) return;
    const params = {
      loanOfficerId: this.selectedLoanOfficersId,
    };
    this.updateReassignDetails(params);
  }

  updateReassignDetails(params) {
    this.clientDashboardService
      .updateAgentConnections(this.activeClient._id, params)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        if (res.isLoading == false) {
          if (params.loanOfficerId) {
            this.isLoanOfficerList = false;
            this.isReassignLoanOfficer = true;
          } else {
            this.isAgentList = false;
            this.isReassignAgent = true;
          }
          this.fetchConnectionDetails(this.activeClient._id);
          this.myControl.reset();
        }
      });
  }

  subscribeLeadFormChanges() {
    this.leadStatusForm.controls.leadType.valueChanges
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((leadType) => {
        this.leadStatusForm.patchValue(
          {
            leadType: leadType,
            leadStatus: '1',
          },
          { emitEvent: false }
        );

        this.leadStatusList = Object.entries(this.appState.companyInfoValue[`${leadType}LeadCategory`]).map(
          ([key, category]: any) => {
            return { index: key, displayText: category.displayText };
          }
        );
      });

    this.leadStatusForm.valueChanges.pipe(takeUntil(this.onDestroyNotifier$)).subscribe(({ leadType, leadStatus }) => {
      const params = {
        leadType: leadType,
        leadStatus: leadStatus,
      };
      this.clientDashboardService
        .updateLeadStatus(this.activeClient._id, params)
        .pipe(takeUntil(this.onDestroyNotifier$))
        .subscribe(({ isLoading }) => {
          this.isSubmitInProgress = isLoading;
          (this.activeClient.leadType = leadType), (this.activeClient.leadStatus = leadStatus);
          this.activeClient.tag = this.clientDashboardService.getStatusTag(leadType, leadStatus);
        });
    });
  }

  resendActivationMail() {
    this.clientDashboardService
      .resendActivationMail(this.activeClient._id)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(({ isLoading }) => {
        this.isResendActivationInProgress = isLoading;
      });
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.clientListForDropdown.filter((option) =>
      (option.firstName + ' ' + option.lastName).toLowerCase().includes(filterValue)
    );
  }

  loadSearch(property) {
    if (!this.authorizeService.canAct('savedFilter')) {
      return false;
    }
    if (property?.appliedFilter?.filters) {
      let location = property?.placeDetails?.fullAddress;
      this.propertyFilterService.setPrimaryFilterToUrl(property.appliedFilter.filters, location || null);
    }
    this.clientDashboardState.openClientDetailsSheetValue = false;
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
    if (this.dataSource) {
      this.dataSource.disconnect();
    }
  }

  addMessage(type, selectedNotes) {
    let investorId = this.activeClient._id;
    let title;
    let selectedNote = selectedNotes;
    if (type == 'add') title = 'Add Note';
    if (type == 'update') title = 'Edit Note';
    if (selectedNote.isOwner == false && type != 'add') title = 'Note';
    const matDialogRef = this.dialog.open(NotesComponent, {
      width: '355px',
      data: {
        title: title,
        investorId: investorId,
        inputValue: selectedNote,
        proceedAction: (notes, callBack) => {
          if (notes) {
            this.updateNotes(notes, selectedNotes);
            matDialogRef.close();
          } else {
            return false;
          }
        },
      },
    });
  }

  updateNotes(note, selectedId) {
    let params = {
      _id: selectedId._id,
      note: note,
      owner: {
        firstName: this.activeClient.firstName,
        lastName: this.activeClient.lastName,
      },
      isOwner: true,
      createdDate: new Date(),
      updatedDate: new Date(),
    };
    if (selectedId._id) {
      this.clientDashboardService
        .updateNotesDetails(selectedId._id, params)
        .pipe(takeUntil(this.onDestroyNotifier$))
        .subscribe((res: any) => { });
    } else {
      this.clientDashboardService
        .addNotesDetails(this.activeClient._id, params)
        .pipe(takeUntil(this.onDestroyNotifier$))
        .subscribe((res: any) => {
          this.paginator1.firstPage();
        });
    }
  }
  openAddSavedSearchSheet() {
    this.clientDashboardState.openAddPropertySearchSheetValue = true;
  }

  deleteNotes(noteId) {
    this.clientDashboardService
      .deleteUserNotes(noteId)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => { });
  }

  deleteSavedSearchForClients(deleteId) {
    if (!this.authorizeService.canAct('savedFilter')) {
      return false;
    }
    if (!deleteId.id) {
      this.openSnackBar('Something went wrong', 'snackbar-error');
      return false;
    }
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '385px',
      disableClose: true,
      hasBackdrop: true,
      // panelClass: 'custom-modalbox',
      data: {
        type: 'deleteSaveSearch',
        message: 'Please note, this will delete the data permanantly',
        title: 'Do you want to continue?',
        proceedAction: (status, callBack) => {
          if (status) {
            this.savedSearchService
              .deleteSavedSearchForClients(deleteId)
              .pipe(takeUntil(this.onDestroyNotifier$))
              .subscribe(
                (res) => {
                  this.openSnackBar(res['message'], 'snackbar-success');
                  callBack({ status: true });
                },
                (err) => {
                  this.openSnackBar(err['message'], 'snackbar-error');
                  dialogRef.close();
                }
              );
          } else {
            return false;
          }
        },
        proceedCancelAction(cancelCallBack) { },
      },
    });
  }

  editSavedSearch(item) {
    this.clientDashboardState.openAddPropertySearchSheetValue = true;
    this.clientDashboardState.savedSearchLocationValue = item.placeDetails;
  }
}
